export default "__VITE_ASSET__B2z9gvjc__";